var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-box"},[_c('vue-qr',{staticClass:"qr-code",attrs:{"text":_vm.url,"size":180,"margin":10}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }